import { BookmarkCheck, BookmarkX, Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthProvider";

export default function NotificationsPage() {
  const { notificationsLoading, handleMarkAsRead, handleDelete, notifications, updatingIds } = useAuth();

  return (
    <div className="mx-auto !py-6 !px-4">
      <h1 className="text-2xl font-bold !mb-4 text-gray-800">All Notifications</h1>

      {notificationsLoading ? (
        <div className="flex justify-center !py-20">
          <Loader2 className="w-8 h-8 animate-spin text-gray-600" />
        </div>
      ) : notifications.length === 0 ? (
        <p className="text-center text-gray-500 !py-10">No notifications available.</p>
      ) : (
        <div className="!space-y-3">
          {notifications.map((n) => (
            <div key={n.id} className={`border border-gray-100 rounded-lg !p-4 bg-white shadow-sm ${!n.is_read ? "bg-gray-50" : ""}`}>
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <p className="text-lg font-semibold text-gray-800 text-left">{n.title}</p>
                  <p className="text-sm text-gray-700 !mt-2 whitespace-pre-wrap text-left">{n.message}</p>
                  <p className="text-sm text-gray-600 !mt-1 text-left">{new Date(n.created_at).toLocaleString()}</p>
                </div>

                <div className="!ml-4 flex flex-col !gap-2">
                  {updatingIds.has(n.id) ? (
                    <Loader2 className="w-5 h-5 animate-spin text-gray-500" />
                  ) : (
                    <div className="flex justify-center item-center space-x-2">
                      {!n.is_read && <BookmarkCheck title="Mark as read" className="w-5 h-5 text-green-500 cursor-pointer hover:text-green-700" onClick={() => handleMarkAsRead(n.id)} />}
                      <BookmarkX title="Delete notification" className="w-5 h-5 text-red-500 cursor-pointer hover:text-red-700" onClick={() => handleDelete(n.id)} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
